/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type AppHolder_manager = {
    readonly uuid: string;
    readonly firstName: string;
    readonly lastName: string;
    readonly profileImageUrl: string | null;
    readonly hasComplianceAccess: boolean;
    readonly company: {
        readonly logoURL: string | null;
        readonly name: string;
        readonly securityProgrammes: {
            readonly pageInfo: {
                readonly total: number;
            };
        };
    };
    readonly " $fragmentRefs": FragmentRefs<"ManagerSlideIn_manager" | "HeaderMenu_manager">;
    readonly " $refType": "AppHolder_manager";
};
export type AppHolder_manager$data = AppHolder_manager;
export type AppHolder_manager$key = {
    readonly " $data"?: AppHolder_manager$data;
    readonly " $fragmentRefs": FragmentRefs<"AppHolder_manager">;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "AppHolder_manager",
    "type": "Manager",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "ScalarField",
            "alias": null,
            "name": "uuid",
            "args": null,
            "storageKey": null
        },
        {
            "kind": "ScalarField",
            "alias": null,
            "name": "firstName",
            "args": null,
            "storageKey": null
        },
        {
            "kind": "ScalarField",
            "alias": null,
            "name": "lastName",
            "args": null,
            "storageKey": null
        },
        {
            "kind": "ScalarField",
            "alias": null,
            "name": "profileImageUrl",
            "args": null,
            "storageKey": null
        },
        {
            "kind": "ScalarField",
            "alias": null,
            "name": "hasComplianceAccess",
            "args": null,
            "storageKey": null
        },
        {
            "kind": "LinkedField",
            "alias": null,
            "name": "company",
            "storageKey": null,
            "args": null,
            "concreteType": "Company",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "logoURL",
                    "args": null,
                    "storageKey": null
                },
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "name",
                    "args": null,
                    "storageKey": null
                },
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "securityProgrammes",
                    "storageKey": "securityProgrammes(page:{\"limit\":0,\"offset\":0})",
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "page",
                            "value": {
                                "limit": 0,
                                "offset": 0
                            }
                        }
                    ],
                    "concreteType": "SecurityProgrammePage",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "pageInfo",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "PageInfo",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "total",
                                    "args": null,
                                    "storageKey": null
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "kind": "FragmentSpread",
            "name": "ManagerSlideIn_manager",
            "args": null
        },
        {
            "kind": "FragmentSpread",
            "name": "HeaderMenu_manager",
            "args": null
        }
    ]
} as any);
(node as any).hash = 'b61d9052398723cc39db323a5cad9ec5';
export default node;
